export default "precision lowp float;\nattribute vec2 position;\n\nvoid main() {\n  gl_Position = vec4(position, 0, 1);\n}";